import React, { createContext, useState, useEffect } from 'react';
import envConfig from '../config/config';

// Create the context
export const ApiHubCardDataContext = createContext();

export const ApiHubCardDataProvider = ({ children }) => {
  const [apiResponse, setApiResponse] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${envConfig.REACT_APP_APIREPO_ADMIN}/apirepo/v0.1/admin/dashboard`, {
          method: 'GET'
        });
        const data = await response.json();

        setApiResponse(data);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, []);

  return (
    <ApiHubCardDataContext.Provider value={{ apiResponse }}>
      {children}
    </ApiHubCardDataContext.Provider>
  );
};
